import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { account } from '../../../classes/Account'
import { RefundOptions as RefundOptionsClass } from './classes/RefundOptions'
import AccelerateOption from './components/AccelerateOption'
import { refreshAccessToken } from '../../../utilities/extensions'
import BuyoutOption from './components/BuyoutOption'

export default function RefundOptions() {
  const navigate = useNavigate()
  const { applicationId } = useParams()

  const [loadingOptions, setLoadingOptions] = useState(true)
  const [refundOptions, setRefundOptions] = useState(new RefundOptionsClass())
  const [selectingRefundOption, setSelectingRefundOption] = useState(false)
  const [registrationLink, setRegistrationLink] = useState('')

  /**
   * @param {Boolean} isAccelerate
   */
  const handleSelectRefundOption = async (isAccelerate) => {
    setSelectingRefundOption(true)

    const refundOptionResponse = await fetch(`${apiURL}/api/applications/${applicationId}/refund-options/`, {
      method: 'POST',
      headers: {
        'Authorization': account.accessToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        isAccelerate
      })
    })
    const refundOptionData = await refundOptionResponse.json()
    if (refundOptionData.response.error) {
      if (refundOptionData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleSelectRefundOption(isAccelerate) : navigate('/', { state: { expired: true } })
      } else
        console.error(refundOptionData.response.error)
    } else
      isAccelerate ? setRegistrationLink(refundOptionData.response.registrationLink) : window.top.location.href = `${apiURL}/applications/${applicationId}/questionnaire`

    setSelectingRefundOption(false)
  }

  useEffect(() => {
    const handleGetRefundOptions = async () => {
      const refundOptionsResponse = await fetch(`${apiURL}/api/applications/${applicationId}/refund-options/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const refundOptionsData = await refundOptionsResponse.json()
      if (refundOptionsData.response.error) {
        if (refundOptionsData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetRefundOptions() : navigate('/', { state: { expired: true } })
        } else
          console.error(refundOptionsData.response.error)
      } else
        setRefundOptions(new RefundOptionsClass(refundOptionsData.response))

      setLoadingOptions(false)
    }

    handleGetRefundOptions()
  }, [])

  return (
    <div className='w-full flex flex-col items-center gap-4 mt-10 px-4 sm:px-8'>
      <div className='w-full h-full flex lg:flex-row flex-col justify-center mt-4 gap-4 flex-1'>
        {!loadingOptions ? (
          !registrationLink ? (
            <div>
              <div className='flex flex-row h-full items-center gap-4 w-full'>
                {(refundOptions.remainingERCCredits >= 100000 && refundOptions.filedOnTime && refundOptions.withPEO) ? (
                  <BuyoutOption
                    withPEO={refundOptions.withPEO}
                    selectingRefundOption={selectingRefundOption}
                    handleSelectRefundOption={handleSelectRefundOption}
                  />
                ) : (
                  <AccelerateOption
                    selectingRefundOption={selectingRefundOption}
                    handleSelectRefundOption={handleSelectRefundOption}
                  />
                )}
              </div>
              {selectingRefundOption && (
                <div className='flex flex-row items-center justify-center gap-2 mt-5'>
                  <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
                  <p className='text-md text-center'>Choosing Option, please do not leave or refresh the page</p>
                </div>
              )}
            </div>
          ) : (
            <div className='flex flex-col h-full items-center justify-center gap-6 w-full mx-auto p-8'>
              <div className='text-center'>
                <h2 className='text-2xl font-bold text-green-600 mb-4'>Success!</h2>
                <p className='text-lg text-gray-700'>You have successfully chosen Accelerate. Click the button below to register for the Accelerate Portal.</p>
              </div>
              <button
                onClick={() => window.top.location.href = registrationLink}
                className='bg-ertc-primary text-white font-semibold px-4 py-2 rounded-md shadow-md'
              >
                Register for Accelerate Portal
              </button>
            </div>
          )
        ) : (
          <div className='flex flex-row items-center justify-center gap-2 mt-5'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
            <p className='text-md text-center'>Loading Options...</p>
          </div>
        )}
      </div>
    </div>
  )
}